<div class="px-4 py-2 border-b">
  <div class="flex items-center justify-between">
    <div *ngFor="let step of steps" class="flex flex-col items-center">
      <div 
        class="flex h-8 w-8 items-center justify-center rounded-full border-2 transition-colors"
        [ngClass]="{
          'border-primary bg-primary text-primary-foreground': currentStep >= step.id,
          'border-muted-foreground bg-background text-muted-foreground': currentStep < step.id
        }">
        <i *ngIf="currentStep > step.id" class="pi pi-check"></i>
        <span *ngIf="currentStep <= step.id">{{ step.id }}</span>
      </div>
      <span 
        class="mt-1 text-xs font-medium"
        [ngClass]="{
          'text-foreground': currentStep >= step.id,
          'text-muted-foreground': currentStep < step.id
        }">
        {{ step.name }}
      </span>
    </div>
  </div>
  <div class="relative mt-1">
    <div class="absolute left-0 top-1/2 h-0.5 w-full -translate-y-1/2 bg-muted"></div>
    <div 
      class="absolute left-0 top-1/2 h-0.5 -translate-y-1/2 bg-primary transition-all"
      [style.width]="progressWidth">
    </div>
  </div>
</div>